import {Feature} from 'molbio/feature-libraries/FeatureLibraryConstants';
import {FEATURE_LIBRARY_BASE_URL} from 'molbio/feature-libraries/FeatureLibraryConstants';

export function moveFeaturesToLibrary(
  featureIds: Array<number>,
  sourceLibraryId: number,
  destinationLibraryId: number
): JQueryPromise<void> {
  return $.ajax({
    type: 'PATCH',
    url: `${FEATURE_LIBRARY_BASE_URL}${sourceLibraryId}/features/`,
    data: JSON.stringify(featureIds.map((featureId) => ({id: featureId, library_id: destinationLibraryId}))),
    contentType: 'application/json',
  });
}

export function deleteFeaturesFromLibrary(featureIds: Array<number>, libraryId: number): JQueryPromise<void> {
  return $.ajax({
    type: 'DELETE',
    url: `${FEATURE_LIBRARY_BASE_URL}${libraryId}/features/`,
    data: JSON.stringify(featureIds),
    contentType: 'application/json',
  });
}

export function updateFeatures(
  featureUpdates: Array<Partial<Feature>>,
  libraryId: number
): JQueryPromise<void> {
  return $.ajax({
    type: 'PATCH',
    url: `${FEATURE_LIBRARY_BASE_URL}${libraryId}/features/`,
    data: JSON.stringify(featureUpdates),
    contentType: 'application/json',
  });
}
